import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import _typeof from "/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configGradeList, productBonusParams, productBonusParamsAdd, productBonusParamsDel } from '../../../../api/apis'; // 默认奖金配置

var DEFAULT_BONUS = {
  '三星': 20,
  '四星': 30,
  '五星': 40,
  '六星': 50,
  '七星': 60,
  '八星': 70,
  '九星': 80
};
var DEFAULT_SHOP_BONUS = 30;
var SHOP_TAG = 'shopReward';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      loaded: false,
      hasParams: false,
      inited: false,
      gradeList: [],
      shopBonus: 0
    };
  },
  mounted: function mounted() {
    var _this = this;

    configGradeList({}).then(function _callee(res) {
      var i, name;
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.gradeList = res.rows;

              for (i in _this.gradeList) {
                name = _this.gradeList[i].name;
                _this.gradeList[i].bonus = DEFAULT_BONUS.hasOwnProperty(name) ? DEFAULT_BONUS[name] : 0;
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      });
    });
  },
  methods: {
    show: function show(product, finish) {
      this.dialogVisible = true;
      this.product = product;
      this.finish = finish;
      this.loaded = false;
      this.hasParams = false;
      this.inited = false;
      this.loadParams();
    },
    // 加载已保存的奖金参数
    loadParams: function loadParams() {
      var _this2 = this;

      this.loading = true;
      productBonusParams({
        product_id: this.product.id
      }).then(function (res) {
        var map = _this2.parseParams(res);

        _this2.hasParams = Object.keys(map).length > 0;

        if (_this2.hasParams) {
          _this2.applyMap(map);
        }

        _this2.loading = false;
        _this2.loaded = true;
      }).catch(function () {
        _this2.hasParams = false;
        _this2.loading = false;
        _this2.loaded = true;
      });
    },
    // 无配置时创建初始数据（仅填充表单，提交后才保存）
    onInit: function onInit() {
      this.applyMap({});
      this.inited = true;
    },
    // 把接口返回解析为 { grade_tag: bonus } 映射
    parseParams: function parseParams(res) {
      var map = {};
      var list = res;

      if (list && list.params !== undefined) {
        list = list.params;
      }

      if (list && list.rows) {
        list = list.rows;
      }

      if (typeof list === 'string') {
        try {
          list = JSON.parse(list);
        } catch (e) {
          list = [];
        }
      }

      if (Array.isArray(list)) {
        for (var i in list) {
          var item = list[i];

          if (item && item.grade_tag !== undefined) {
            map[item.grade_tag] = item.bonus;
          }
        }
      } else if (list && _typeof(list) === 'object') {
        map = list;
      }

      return map;
    },
    // 应用映射到表单
    applyMap: function applyMap(map) {
      var tmp = this.gradeList;

      for (var i in tmp) {
        var name = tmp[i].name;
        var def = DEFAULT_BONUS.hasOwnProperty(name) ? DEFAULT_BONUS[name] : 0;
        var key = 'grade' + tmp[i].tag;
        tmp[i].bonus = map[key] !== undefined ? map[key] : def;
      }

      this.shopBonus = map[SHOP_TAG] !== undefined ? map[SHOP_TAG] : DEFAULT_SHOP_BONUS;
      this.gradeList = this.$tempModel.deepCopy(tmp);
    },
    clickSubmit: function clickSubmit() {
      var _this3 = this;

      var params = {};

      for (var i in this.gradeList) {
        var item = this.gradeList[i];
        params['grade' + item.tag] = item.bonus;
      }

      params[SHOP_TAG] = this.shopBonus;
      this.$g.fun.startLoading();
      productBonusParamsAdd({
        product_id: this.product.id,
        params: params
      }).then(function _callee2(res) {
        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$message({
                  message: '设置成功',
                  type: 'success'
                });

                _this3.$g.fun.endLoading();

                _this3.dialogVisible = false;

                _this3.finish();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        });
      }).catch(function () {
        _this3.$g.fun.endLoading();
      });
    },
    clickDelete: function clickDelete() {
      var _this4 = this;

      this.$confirm('确认删除该产品的奖金参数配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.$g.fun.startLoading();

        productBonusParamsDel({
          product_id: _this4.product.id
        }).then(function (res) {
          _this4.$message({
            message: '删除成功',
            type: 'success'
          });

          _this4.$g.fun.endLoading();

          _this4.dialogVisible = false;

          _this4.finish();
        }).catch(function () {
          _this4.$g.fun.endLoading();
        });
      }).catch(function () {});
    }
  }
};